export enum SupplierAvailabilityStateFilter {
  Available = 0,
  SpareCapacity = 1,
}
